/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import type { THueVariationString, TIntent, TSize } from 'volta/utils/style-utils';
import type { BvTooltipSignature } from 'volta/components/bv-tooltip';
import type { ContentValue } from '@glint/template';

type TTagSize = Extract<TSize, 'sm' | 'md' | 'lg'>;
const SIZES: TTagSize[] = ['sm', 'md', 'lg'];

type IColor = TIntent | 'primary';
const COLORS: IColor[] = ['primary', 'success', 'danger', 'warning', 'info'];

export interface BvTagSignature {
  Args: {
    text?: ContentValue;
    size?: TTagSize;
    color?: THueVariationString;
    disabled?: boolean;
    fullWidth?: boolean;
    class?: string;
    textClass?: string;
    buttonLabel?: string;
    tooltip?: BvTooltipSignature['Args']['text'];
    onRemove?: (e: Event) => void;
    onClick?: (e: MouseEvent) => void;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLElement;
}

export default class BvTagComponent extends Component<BvTagSignature> {
  get sizeClass() {
    const { size } = this.args;
    return `bv-tag--${size && SIZES.includes(size) ? size : 'md'}`;
  }

  get colorClass() {
    const { color } = this.args;
    return color && COLORS.includes(color as IColor) && `bv-tag--${color}`;
  }

  @action
  handleMouseUp(e: MouseEvent) {
    const { currentTarget } = e;

    if (currentTarget && typeof (currentTarget as HTMLButtonElement)['blur'] === 'function') {
      (currentTarget as HTMLButtonElement).blur();
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvTag: typeof BvTagComponent;
    'bv-tag': typeof BvTagComponent;
  }
}
